module.exports = "<div class=box> <div class=\"box-row content-box\"> <div class=box-cell> <div class=\"box-inner padding-box\" ui-view id=view> </div> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/layout/contentNoBreadcrumb.html
// module id = 299
// module chunks = 0